import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouttekuk() {
  return (
    <section className="abouttek_uk p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="order-md-1 order-2 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/dot_net/effc_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={594}
              height={650}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 order-md-2 order-1"
          >
            <h2>Delivering Unmatched Flexibility, Quality, and Efficiency</h2>
            <p>
              At TekRevol, we deeply understand the hurdles companies encounter
              when seeking to hire .NET developers. As a leading IT staffing and
              augmentation agency, we distinguish ourselves by connecting you
              with top-tier .NET programmers within just two working days.
              Additionally, our zero-day exit policy ensures you have the utmost
              flexibility to adapt to your evolving needs without any delay.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire Your .Net Developers Now
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouttekuk;
